import ElgigantenSmall from "../assets/elgiganten/elgiganten_sm.svg";
import favicon from "../assets/elgiganten/favicon/android-chrome-512x512.png";

export const Elgiganten_brandVariables = {
  siteTitle: "Elgiganten",
  siteIcon: favicon,
  name: "Elgiganten",
  name_small: "Elgiganten",
  logos: {
    large: ElgigantenSmall,
    white: ElgigantenSmall,
    small: ElgigantenSmall,
    medium: ElgigantenSmall,
    alt_text: "Elgiganten logo",
    profile: ElgigantenSmall,
  },
  brandTheme: "elgiganten", // Theme of the brand
  site: "", // Live url of site
  authMethod: "email", // Only needed for events, gives user set options to manualy sign up, options are:  email | phone
  defaultCountryCode: "SE", // Only needed for retail platforms | For initial phone number | Changes all auth methods`
  defaultLanguage: "no",
  brandStoreExtension: "", // Only needed for retail platforms | Extension used for email
  brandValue: "ELGIGANTEN", // Only needed for retail platforms | Brand value needed for BE related functions
  brandIntials: "el", // gets added after the username, to drasticaly descrease chance of duplicate usernames across different apps | Only needed for event platforms
  defaultNavigateUrl: "/",
  eventHasAutoQrSignup: false,
  hasSubClients: true,
  subClientsForOverviews: ["TCL"], // string[] of clients used to fetch multiple types of clients for overview pages
  autoJoinChallenge: true, // FIX BEFORE DREAMHACK
  hasFeature: {
    notifications: false,
    themes: false,
    connections: false,
    achievements: false,
    quickSignUp: false,
    messages: false,
    teams: false,
    news: false,
    challenges: true,
    singleChallenge: true,
    gathers: false,
    preferences: false,
    friends: false,
    zones: false,
    feed: false,
    winners: false,
    qrSignUp: true,
    manualSubmissions: false,
    landing: true,
    login: true,
    haslanguagePicker: true,
    getstarted: false,
    hero: false,
    search: false,
    routes: true,
    dailytasks: false,
    games: false,
    treasure_hunt: false,
    activities: false,
    changePassword: false,
  },
  hasAuth: {
    steam: false,
    bnet: false,
    quickSignUp: true,
    google: true,
    discord: true,
    twitch: true,
  },
  layout: {
    challenge: "event",
  },
  event: {
    forcedCredentialPopup: "",
    eventCode: "elgiganten_livestream_oct_2024", // Only needed for event platforms
    collectionForSubmissions: "",
    documentForSubmissions: "",
    isEvent: true,
    spacecoins_redirect: true,
  },
};
